import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;
const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const SuppliesService = {
    list: async () => axios.post(`${API_URL}/supplies/list`).then(({ data }) => data).catch((err) => { throw err }),
    getById: async (id) => axios.get(`${API_URL}/supplies/${id}`).then(({ data }) => data).catch((err) => { throw err }),
    create: async (data) => axios.post(`${API_URL}/supplies`, data).then(({data}) => data).catch((err) => { throw err }),
    update: async (id, data) => axios.post(`${API_URL}/supplies/${id}`, data).then(({data}) => data).catch((err) => { throw err }),
    delete: async (id) => axios.delete(`${API_URL}/supplies/${id}`).then(({ data }) => data).catch((err) => { throw err }),
    export: async (data) => axios.post(`${API_URL}/supplies/export`, data, { responseType: "blob" }).then(({ data }) => data).catch((err) => { throw err }),
    vehicles: async () => axios.get(`${API_URL}/vehicles/options/all`).then(({data}) => data.data.map(d => ({value: d.id, label: d.text, actual_km: d.actual_km}))).catch((err) => { throw err }),
    gasStations: async (gasStation = null, id = null) => {
        const url = gasStation && id
            ? `${API_URL}/places/options/gasStations/${gasStation}/${id}`
            : `${API_URL}/places/options/gasStations/null`;

        return axios.get(url).then(({ data }) => data).catch((err) => { throw err });
    },
    getAttach: async (id) => axios.get(`${API_KEEPER}/ged/attach/${id}`, {responseType: "blob"}).then(res => res.data),
};

export default SuppliesService;
